import React from 'react';
import SMDashboardBaseView from 'components/dashboard/shared/SMDashboardBaseView';

class SMUSettingEditBaseFragment extends SMDashboardBaseView {
  
  fragmentStyle(){
    return {
      display: this.state.isCurrent ? "block" : "none"
    };
  }
  
  isCurrent(props){
    return props.selectedFragment == props.fragmentIndex;
  }
  
  sizeToFit() {
    var $mainTable = $("#js-split_view-main"),
        $mainTableFooter = $(this.refs.mainTableFooter);
        
    // main
    $mainTableFooter.outerWidth($mainTable.outerWidth());
  }
}
export default SMUSettingEditBaseFragment;



// WEBPACK FOOTER //
// ./app/javascript/components/dashboard/users/settings/fragments/SMUSettingEditBaseFragment.jsx